import { AccordionSummaryProps } from '@material-ui/core';

export const accordionSummary: AccordionSummaryProps = {
  IconButtonProps: {
    disableRipple: true,
  },
};
